import Login from './login';
import SetPassword from './set-password';
import SingUp from './sing-up';
import ForgotPassword from './forgot-password';

export default Login;
export {SingUp, SetPassword, ForgotPassword};
